import React from 'react'

export const Acknowledgement: React.FC = ({ children }) => {
  return <div className="p-8 font-bold italic text-center">{children}</div>
}
